export default "__VITE_ASSET__A6TWP0T3__"